const formTools = {
    translations: {
        'uk': {
            phone_required: 'Введіть номер телефону',
            name_required: 'Введіть ім\'я',
            surname_required: 'Введіть прізвище',
            email_required: 'Введіть email',
            minlength: 'Введіть більше двох символів',
            email_invalid: 'Недійсна електронна адреса',
            load_up_to: 'Завантажити файли (до 5 МБ)',
        },
        'ru': {
            phone_required: 'Введите номер телефона',
            name_required: 'Введите имя',
            surname_required: 'Введите фамилию',
            email_required: 'Введите email',
            minlength: 'Введите больше двух символов',
            email_invalid: 'Неверный адрес электронной почты',
            load_up_to: 'Загрузить файлы (до 5 МБ)',
        },
        'en': {
            phone_required: 'Enter your phone number',
            name_required: 'Enter name',
            surname_required: 'Enter surname',
            email_required: 'Enter email',
            email_invalid: 'Invalid email',
            minlength: 'Enter more than two characters',
        },
    },

    addLead: function (formData, form) {
        const btn = form.find('.send_form');
        btn.prop('disabled', true);

        $.ajax({
            url: requests.postSend,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status === "ok") {
                    form.find('.form__item').val('');
                    form.find('.upload-name').text(formTools.translations[lang]['load_up_to'] || 'Upload files (up to 5MB)');

                    const successBlock = form.closest('.main-wrap').find('.modal__success');
                    successBlock.addClass('active');

                    setTimeout(function () {
                        successBlock.removeClass('active');
                        window.location.reload();
                    }, 3000);
                }
            },
            complete: function () {
                btn.prop('disabled', false);
            }
        });
    },

    addOrder: function (formData, form) {
        const btn = form.find('.send_form');
        btn.prop('disabled', true);

        $.ajax({
            url: requests.sendOrder,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function (data) {
                if (data.status === "liqpay" && data.liqpay_form) {
                    $('body').append(data.liqpay_form);
                    $('body').find('form[action*="liqpay"]').last().submit();
                    return;
                }

                if (data.status === "success" || data.status === "ok") {

                    if (typeof gtag === 'function') {
                        gtag('event', 'generate_lead', {
                            event_category: 'form',
                            event_label: 'order'
                        });
                    }

                    form.find('.form__item').val('');
                    form.find('.upload-name').text(formTools.translations[lang]['load_up_to'] || 'Upload files (up to 5MB)');

                    setTimeout(function () {
                        window.location.href = '/gratitude-page';
                    }, 300);

                    // const successBlock = form.closest('.main-wrap').find('.modal__success');
                    // successBlock.addClass('active');
                    //
                    // setTimeout(function () {
                    //     successBlock.removeClass('active');
                    //     window.location.reload();
                    // }, 3000);
                }
            },
            complete: function () {
                btn.prop('disabled', false);
            }
        });
    },

    displayFileInfo: function (files, uploadNameElement) {
        if (files.length === 0) {
            uploadNameElement.text(this.translations[lang]['load_up_to'] || 'Upload files (up to 5MB)');
            return;
        }

        let fileInfo = '';
        Array.from(files).forEach((file, index) => {
            const fileName = file.name;
            const fileSize = (file.size / 1024 / 1024).toFixed(2); // Convert to MB
            const fileExtension = fileName.split('.').pop().toLowerCase();
            fileInfo += `${fileName} (${fileSize} MB, ${fileExtension})`;
            if (index < files.length - 1) {
                fileInfo += '<br>';
            }
        });
        uploadNameElement.html(fileInfo);
    },

    initValidate: function (node = '.main-form') {
        $(node).each(function () {
            $(this).validate({
                rules: {
                    first_name: {
                        required: true,
                        minlength: 2
                    },
                    last_name: {
                        required: true,
                        minlength: 2
                    },
                    // email: {
                    //     required: true,
                    //     email: true,
                    //     minlength: 2
                    // },
                    phone: {
                        required: true,
                    },
                },
                messages: {
                    first_name: {
                        required: formTools.translations[lang]['name_required'],
                        minlength: formTools.translations[lang]['minlength'],
                    },
                    last_name: {
                        required: formTools.translations[lang]['surname_required'],
                        minlength: formTools.translations[lang]['minlength'],
                    },
                    email: {
                        required: formTools.translations[lang]['email_required'],
                        email: formTools.translations[lang]['email_invalid'] || 'Invalid email',
                        minlength: formTools.translations[lang]['minlength'],
                    },
                    phone: {
                        required: formTools.translations[lang]['phone_required'],
                    },
                }
            });

            const form = $(this);
            const fileInput = form.find('input[type="file"]');
            const uploadNameElement = form.find('.upload-name');

            fileInput.on('change', function () {
                formTools.displayFileInfo(this.files, uploadNameElement);
            });
        });
    }
}

$(document).ready(function () {
    formTools.initValidate();
    $(document).on('click', '.send_form', function (e) {
        e.preventDefault();
        const form = $(this).closest('.main-form');
        const name = form.attr('data-subject');
        if (!form.valid()) {
            return;
        }

        const formData = new FormData(form[0]);
        formData.append('subject', form.attr('data-subject'));

        if (name == 'order') {
            formTools.addOrder(formData, form);
        } else {
            formTools.addLead(formData, form);
        }
    });
});
window.initValidate = formTools.initValidate;
